import React, { useState } from "react";
import styled from "styled-components";
import { SectionLabel } from "./About";
import theme from "../../../../assets/theme";
import { Images } from "../../../../assets/images";
import { H2 } from "../../AboutUs/Styles";

const features = [
  {
    icon: Images.independent,
    title: "Credible & Independent",
    bgColor: "#27ae60",
  },
  {
    icon: Images.Saas,
    title: "Proven, Client-Integrated Workflows",
    bgColor: "#3498db",
  },
  {
    icon: Images.technology,
    title: "AI-Powered Differentiation",
    bgColor: "#9b59b6",
  },
  {
    icon: Images.agreement,
    title: "Enforceability & Execution Support",
    bgColor: "#e74c3c",
  },
  {
    icon: Images.professionals,
    title: "Curated Arbitrator & Mediator Network",
    bgColor: "#f39c12",
  },
];

const JustActComponent = () => {
  // const [currentVideoSet, setCurrentVideoSet] = useState(0);
  const [playingVideo, setPlayingVideo] = useState(null);
  const currentVideoSet = 0;

  const videoSets = [
    [
      {
        title: "IAMC (English) - AI Driven Negotiation",
        language: "English",
        youtubeId: "Ra5eZIe5_80",
        embedUrl: "https://www.youtube.com/embed/Ra5eZIe5_80",
      },
      {
        title: "IAMC (Hindi) - AI Driven Negotiation",
        language: "Hindi",
        youtubeId: "dsYc3_w0ln8",
        embedUrl: "https://www.youtube.com/embed/dsYc3_w0ln8",
      },
    ],
  ];

  const handleVideoPlay = (videoIndex) => {
    setPlayingVideo(playingVideo === videoIndex ? null : videoIndex);
  };

  /*
  const handleVideoNavigation = (direction) => {
    setPlayingVideo(null); // Stop any playing video when navigating
    if (direction === "prev" && currentVideoSet > 0) {
      setCurrentVideoSet(currentVideoSet - 1);
    } else if (direction === "next" && currentVideoSet < videoSets.length - 1) {
      setCurrentVideoSet(currentVideoSet + 1);
    }
  };
  */

  return (
    <Container>
      <Header>
        <SectionLabel textAlign="center" style={{ marginBottom: 5 }}>
          Why IAMC
        </SectionLabel>
        <H2 style={{ marginBottom: "40px" }}>
          India's Independent ODR Institution
        </H2>
        <CardGrid>
          {features.map((feature, index) => (
            <Card key={index}>
              <ImageContainer>
                <Image src={feature.icon} alt={feature.title} />
              </ImageContainer>
              <TextContent>
                <Heading>{feature.title}</Heading>
              </TextContent>
            </Card>
          ))}
        </CardGrid>
      </Header>

      <WorksSection>
        <H2
          style={{
            textAlign: "center",
            marginBottom: "30px",
            marginTop: "30px",
          }}
        >
          How IAMC Works
        </H2>
        <WorksContent>
          <WorksDescription>
            <p>
              IAMC offers <a href="#negotiation">Negotiation</a> as a
              technology assisted mediation which uses a Game Theory based
              algorithm to throw up a settlement number and will use AI to
              improve over time.
            </p>
            <p>
              On the other hand, for <a href="#mediation">Mediation</a> and{" "}
              <a href="#arbitration">Arbitration</a>, it adopts the aggregator
              model by sourcing cases online and having tie ups with reputed
              arbitration / mediation institutes and independent professionals
              to resolve disputes
            </p>
          </WorksDescription>

          <VideoSection>
            {videoSets[currentVideoSet].map((video, index) => (
              <VideoCard key={index}>
                <VideoThumbnail onClick={() => handleVideoPlay(index)}>
                  {playingVideo === index ? (
                    <YouTubeIframe
                      src={`${video.embedUrl}?autoplay=1&rel=0&modestbranding=1`}
                      title={video.title}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  ) : (
                    <>
                      <VideoOverlay showOverlay={true}>
                        <PlayButton />
                      </VideoOverlay>
                      <img
                        src={`https://img.youtube.com/vi/${video.youtubeId}/maxresdefault.jpg`}
                        alt={video.title}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          position: "absolute",
                          top: 0,
                          left: 0,
                        }}
                        onError={(e) => {
                          e.target.src = `https://img.youtube.com/vi/${video.youtubeId}/hqdefault.jpg`;
                        }}
                      />
                    </>
                  )}
                </VideoThumbnail>
              </VideoCard>
            ))}
          </VideoSection>

          {/* <NavigationButtons>
            <NavButton
              onClick={() => handleVideoNavigation("prev")}
              disabled={currentVideoSet === 0}
            >
              ←
            </NavButton>
            <NavButton
              onClick={() => handleVideoNavigation("next")}
              disabled={currentVideoSet === videoSets.length - 1}
            >
              →
            </NavButton>
          </NavigationButtons> */}
        </WorksContent>
      </WorksSection>
    </Container>
  );
};

export default JustActComponent;

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  overflow-x: hidden;
`;

const Header = styled.div`
  text-align: center;
  padding: 2rem 1rem;

  @media (max-width: 768px) {
    padding: 1.5rem 0.5rem;
  }
`;

const WorksSection = styled.section`
  background: #e6f3f4;
  margin: 2rem 0 2rem;
  padding: 1rem 2rem 3rem;

  @media (max-width: 768px) {
    margin: 3rem 0 1rem;
    padding: 2rem 1rem;
  }
`;

const WorksContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
`;

const WorksDescription = styled.div`
  margin-bottom: 3rem;

  p {
    font-family: ${theme.fonts.primaryFontRegular};
    color: #293461;
    font-size: clamp(1rem, 2.5vw, 1.1rem);
    line-height: 1.6;
    margin-bottom: 1rem;
  }

  a {
    color: #00838c;
    text-decoration: none;
    font-weight: 600;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const VideoSection = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 2rem;
  margin-top: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const VideoCard = styled.div`
  background: #f8f9fa;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  }
`;

export const VideoThumbnail = styled.div`
  aspect-ratio: 16/9;
  background: linear-gradient(
    90deg,
    rgba(42, 123, 155, 1) 0%,
    rgba(87, 199, 133, 1) 50%,
    #949ab0 100%
  );
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  overflow: hidden;
`;

export const YouTubeIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 0;
`;

export const PlayButton = styled.div`
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  position: relative;
  z-index: 2;

  &:hover {
    background: white;
    transform: scale(1.1);
  }

  &::after {
    content: "";
    width: 0;
    height: 0;
    border-left: 25px solid #00818a;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    margin-left: 5px;
  }
`;

export const VideoOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${(props) => (props.showOverlay ? 1 : 0)};
  transition: opacity 0.3s ease;
  z-index: 1;
  cursor: pointer;
`;

export const NavigationButtons = styled.div`
  display: flex;
  justify-content: right;
  gap: 1rem;
  margin-top: 2rem;
`;

export const NavButton = styled.button`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: none;
  background: #00818a;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    background: #00818a;
    transform: scale(1.1);
  }

  &:disabled {
    background: #bdc3c7;
    cursor: not-allowed;
    transform: none;
  }
`;

export const CardGrid = styled.div`
  display: grid;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 1rem;
  gap: 2rem;

  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));

  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.div`
  border-radius: 1.2rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  text-align: left;
  display: flex;
  flex-direction: column;
  transition: transform 0.4s ease, box-shadow 0.4s ease;
  background: white;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
  }
`;

export const ImageContainer = styled.div`
  height: 220px;
  overflow: hidden;
  position: relative;

  @media (max-width: 1023px) {
    height: 200px;
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s ease;

  ${Card}:hover & {
    transform: scale(1.05);
  }
`;

export const TextContent = styled.div`
  padding: 1.8rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  flex-grow: 1;
`;

export const Heading = styled.h3`
  font-size: 16px;
  color: #00838c;
  font-weight: 600;
  margin: 0;

  @media (max-width: 1200px) {
    font-size: 1.15rem;
  }
`;
